/**
 * Guards a dynamic `<component :is>` outlet against rendering an unresolved route component.
 *
 * When a lazy route (`() => import(...)`) is rendered through
 * `<RouterView v-slot="{ Component }"><Transition mode="out-in"><component :is="Component" /></Transition></RouterView>`,
 * the transition can briefly expose the raw loader function before vue-router resolves it.
 * `<component :is="loaderFn">` then treats the loader as a functional component, calls it, and
 * renders the returned Promise as the text `[object Promise]`. A bare Promise renders as an empty
 * node. Only resolved components (plain objects: SFCs or `defineAsyncComponent` wrappers) are safe
 * to render, so skip anything that is still a function or a thenable.
 */
export function isRenderableRouteComponent(component: unknown): boolean {
   if (!component) return false;
   if (typeof component === 'function') return false;
   if (typeof (component as { then?: unknown }).then === 'function') return false;
   return true;
}
